import React, { useEffect } from 'react';

// The FAQ is canonical at groovie.live/faq (single source of truth). This dashboard page
// used to carry its own February-vintage copy with stale free-trial / plan-proration /
// pricing-page claims; it now redirects to the canonical page.
export default function FAQ() {
  useEffect(() => { window.location.replace('https://groovie.live/faq'); }, []);
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'rgba(255,255,255,0.55)', fontFamily: "'Outfit', -apple-system, sans-serif", fontSize: 14 }}>
      Redirecting to&nbsp;<a href="https://groovie.live/faq" style={{ color: '#a855f7' }}>groovie.live/faq</a>…
    </div>
  );
}
